// Navigate to check availability form on price button click
var hotelMenuMixin = {
		data: {
			hasDiscount: false,
			lowestDiscountHTML: '',
			hasReviews: false
		},
		methods: {
			getFixedHeaderHeight: function() {
				return win.isMobile ? 0 : -gE('header-hotel-fixed').offsetHeight || -65;
			},
			clickPrices: function(e) {
				e.preventDefault();
				if (win.availCheckForm) {
					$d.scrollto({ distance: this.getFixedHeaderHeight(), 
						toElement: qS('.avail-check-wrapper'), 
						callback: function() {
						  if (win.rooms && !win.rooms.rooms.length) {
							  win.alert(this.i18n.availabilityInstruction);
						  }
						}
					});
				} else {
					location.href = $url.encodeVar({q : $url.encodeQ(this.sharedState.query), sl: 6}, 
                    	{url: win.internalUrl.hotelDetail });
				}
			},
			clickPhotos: function(e) {
				e.preventDefault();
				if (win.showCarousel) {
					win.showCarousel();
				} else {
					location.href = $url.encodeVar({q : $url.encodeQ(this.sharedState.query), sl: 9}, 
                    	{url: win.internalUrl.hotelDetail });
				}
			},
			clickTripAdvisor: function(e) {
				e.preventDefault();
				e.stopPropagation(); // to prevent firing close popup event
				win.popup.show(win.externalUrl.tripAdvisor);
			},
			clickTab: function(e, tabName) {
				e.preventDefault(); 
				if (win.hotelInfoTabs) {
					win.hotelInfoTabs.activeTab = tabName;
					$d.scrollto({ distance: this.getFixedHeaderHeight(), toElement: gE('hotel-info-tabs') });
				} else {
					location.href = $url.encodeVar({q : $url.encodeQ(this.sharedState.query)}, 
                    	{url: win.internalUrl.hotelDetail, hash: tabName });
				}
			},
			clickPhotosScroll: function(e) {
				this.clickPhotos(e);
				$d.scrollto({ toElement: gE('hotel-photos') });
			}
		}
	};

// main menu tabs
var hotelHeaderMenu = vueIfExists({
	mixins: [hotelMenuMixin, win.map],
	el: '#header-hotel-menu', 
	data: {
		sharedState: win.store.state
	},
	mounted: function() {
		Vue.nextTick(function(caller) {return function() {
			if (caller.sharedState.siteLink == 'hotelMap') {
				caller.showHotelIdMap(caller.sharedState.destinationIndex);
			}
	    };}(this));
	},
	methods: {
		setDiscountLabel: function(discount) {
			// this.hasDiscount = true;
			this.sharedState.maximumDiscountHTML = discount > 4 ? this.i18n.upToXoff
				.replace('%0%', Math.round(discount)+'%')
				.replace('%1%', '-')
				.replace('%2%', '<strong>').replace('%3%', '</strong>') : '';
		}
	}
});
	
// fixed menu tabs container
var hotelHeaderMenuFixed = vueIfExists({
	mixins: [hotelMenuMixin, win.map],
	el: '#header-hotel-fixed',
	data: {
		sharedState: win.store.state,
		$scrollTarget: undefined,
		hotelHeaderObserver: undefined
	},
	mounted: function() {
		this.$scrollTarget = qS('.header-hotel');
		if ("IntersectionObserver" in window) {
			this.hotelHeaderObserver = new IntersectionObserver( function(caller) { return function(entries, observer) {
				caller.toggle(!entries[0].isIntersecting); };
			}(this)).observe(this.$scrollTarget);
		} else {
			window.addEventListener('scroll', this.onScroll);
			this.onScroll();
		}
	},
	beforeDestroy: function() {
		if ("IntersectionObserver" in window) {
			this.hotelHeaderObserver.unobserve(this.$scrollTarget);
		} else {
			window.removeEventListener('scroll', this.onScroll);
		}
	},
	methods: {
		onScroll: function() {
			var scrollTarget = this.$scrollTarget.getBoundingClientRect().top + this.$scrollTarget.offsetHeight;
			this.toggle(scrollTarget < 0);
		},
		toggle: function(show) {
			if (show) {
		      this.$el.classList.add('fixed-menu-show');
		    } else {
		      this.$el.classList.remove('fixed-menu-show');
			}
		},
	}
});

// main menu tabs
var hotelMobileMenu = vueIfExists({
	mixins: [hotelMenuMixin, win.map],
	el: '#mobile-hotel-menu', 
	data: {
		sharedState: win.store.state
	}
});